import { render, staticRenderFns } from "./list.vue?vue&type=template&id=8f82d0e2&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=8f82d0e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f82d0e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f82d0e2')) {
      api.createRecord('8f82d0e2', component.options)
    } else {
      api.reload('8f82d0e2', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=8f82d0e2&scoped=true", function () {
      api.rerender('8f82d0e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Category/list.vue"
export default component.exports